"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
const styled_1 = __importDefault(require("@emotion/styled"));
const emotion_grid_1 = require("@mverissimoo/emotion-grid");
const StyledContainer = (0, styled_1.default)(emotion_grid_1.Container)(({ noPadding }) => ({
    ...(noPadding &&
        (0, react_1.css) `
        ${(0, emotion_grid_1.media)('xs')} {
          padding-left: 0;
          padding-right: 0;
        }

        .EmotionGrid-Row {
          margin-left: 0;
          margin-right: 0;
        }

        .EmotionGrid-Col {
          padding-left: 0;
          padding-right: 0;
        }
      `)
}));
exports.default = StyledContainer;
//# sourceMappingURL=StyledContainer.js.map